import React from 'react';
import PropTypes from 'prop-types';
import './WeekOverview.css';

const Header = ({ label, sublabel }) => (
  <div className='week-overview-date-container-header'>
    <span className='date-text'>{label}</span>
    <span className='date-sub-text'>{sublabel}</span>
  </div>
);

Header.propTypes = {
  label: PropTypes.string,
  sublabel: PropTypes.string
};

export default Header;
